import styled from '@emotion/styled';
import { css } from 'emotion';

export const EpisodeContentLabel = styled.h2`
  margin-bottom: 16px;
  color: #24203f;
  font-size: 2.4rem;
`;

export const UploaderStateContainer = styled.div<{
  containsMedia: boolean;
  isExpanded: boolean;
  isDragging: boolean;
}>`
  width: 100%;
  height: ${({ isExpanded }) => (isExpanded ? '152' : '100')}px;
  border: 1px ${({ isDragging }) => (isDragging ? '#5000B9' : '#dedfe0')}
    ${({ containsMedia }) => (containsMedia ? 'solid' : 'dashed')};
  border-radius: 8px;
  background: ${({ isDragging }) =>
    isDragging ? 'rgba(80, 0, 185, 0.03)' : '#ffffff'};
`;

export const ContentWrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  text-align: left;
`;

export const UploaderContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const UploaderContentsContainer = styled.div`
  width: 100%;
`;

export const UploaderLabelsContainer = styled.div`
  display: block;
  margin-left: 12px;
`;

export const UploaderStatusHeading = styled.h2`
  margin: 0 0 8px 0;
  color: #24203f;
  font-size: 1.8rem;
  line-height: 21px;
`;

export const UploaderStatusLabel = styled.div`
  color: #7f8287;
  font-size: 1.2rem;
  line-height: 14px;
`;

export const UploaderStatusContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const uploaderCancelButtonStyle = css`
  width: 112px;
  height: 40px;
  color: #9a201c;
`;
